import Home from './components/home/home';
import MyArticles from './components/my-articles/articles/articles';
import Article from './components/my-articles/article/article';
import RecommendedArticles from './components/editor-recommendations/recommended-articles/recommended-articles';

import Newsletters from './components/newsletters/newsletters';
import NewslettersCatalog from './components/newsletters/newsletters-catalog';
import Newsletter from './components/newsletters/newsletter';
import OpenSource from './components/open-source';
import Community from './components/community';
import IsAngularReadyYet from './components/ready-yet/is-angular-ready-yet';
import DailyNews from './components/daily-news';
import DailyNewsArticle from './components/daily-news/daily-news-article';
import AutoPost from './components/daily-news/auto-post';
import FuturePost from './components/daily-news/future-post';
import FuturePostsEditor from './components/daily-news/future-posts-editor';
import NewsletterGenerator from './components/newsletters/newsletter-generator';
import BEArticlesSummary from './components/daily-news/be-articles-summary';
import DeleteDailyNews from './components/daily-news/be-delete-daily-news';
import TrendingNewsArticle from './components/trending-news/trending-news-article';
import TeamMembers from './components/team-members';
import TeamMember from './components/team-members/team-member';
import NewHome from './components/new-home';
import NewsletterSubscription from './components/newsletters/newsletter-subscription';
import AdminStatsPage from './components/admin-stats';
import TwitterInstagramCandidates from './components/twitter-instagram/candidates';
import TwitterInstagramMessaging from './components/twitter-instagram/messaging';
import InstagramCandidates from './components/instagram/candidates';
import InstagramCandidatesAutoNames from './components/instagram/candiates-auto-names';
import DailyNewsBatchManager from './components/daily-news/daily-news-batch-manager';

const routes = [
  {
    path: '/',
    component: NewHome,
    exact: true
  },
  // {
  //   path: '/home',
  //   component: NewHome,
  //   exact: true
  // },  
  {
    path: '/articles',
    component: MyArticles,
    exact: true
  },
  {
    path: '/articles/:linkId',
    component: Article,
    exact: true
  },
  {
    path: '/recommendations',
    component: RecommendedArticles,
    exact: true
  },
  {
    path: '/newsletters',
    component: NewslettersCatalog,
    exact: true
  },
  {
    path: '/newsletters/ag/:tag',
    component: Newsletters,
    exact: true
  },  
  {
    path: '/newsletters/:id',
    component: Newsletter,
    exact: true
  },
  {
    path: '/newsletters/ag/:tag/subscription',
    component: NewsletterSubscription,
    exact: true
  },  
  {
    path: '/newsletters/ag/:tag/:id',
    component: Newsletter,
    exact: true
  },
  {
    path: '/newsletter-generator',
    component: NewsletterGenerator,
    exact: true
  },    
  {
    path: '/newsletter-generator/ag/:tag',
    component: NewsletterGenerator,
    exact: true
  },  
  {
    path: '/open-source',
    component: OpenSource,
    exact: true
  },
  {
    path: '/community',
    component: Community,
    exact: true
  },
  {
    path: '/team',
    component: TeamMembers,
    exact: true
  },
  {
    path: '/team/:name',
    component: TeamMember,
    exact: true
  },  
  {
    path: '/is-angular-v5-ready-yet',
    component: IsAngularReadyYet,
    exact: true
  },
  {
    path: '/daily-news',
    component: DailyNews,
    exact: true
  },
  {
    path: '/daily-news/auto-post/*',
    component: AutoPost,
    exact: false
  },
  {
    path: '/daily-news/future-post/*',
    component: FuturePost,
    exact: false
  },  
  {
    path: '/daily-news/future-posts-editor',
    component: FuturePostsEditor,
    exact: true
  },    
  {
    path: '/daily-news/summary',
    component: BEArticlesSummary,
    exact: true
  },
  {
    path: '/daily-news/delete/:id',
    component: DeleteDailyNews,
    exact: true
  },
  {
    path: '/daily-news/:linkId',
    component: DailyNewsArticle,
    exact: true
  },
  {
    path: '/trending-news/:linkId',
    component: TrendingNewsArticle,
    exact: true
  },
  {
    path: '/admin-stats',
    component: AdminStatsPage,
    exact: true
  },
  {
    path: '/twitter-instagram-candidates',
    component: TwitterInstagramCandidates,
    exact: true
  },
  {
    path: '/twitter-instagram-messaging',
    component: TwitterInstagramMessaging,
    exact: true
  },
  {
    path: '/instagram-candidates',
    component: InstagramCandidates,
    exact: true
  },  
  {
    path: '/instagram-candidates-auto-names',
    component: InstagramCandidatesAutoNames,
    exact: true
  },  
  {
    path: '/daily-news-batch-manager',
    component: DailyNewsBatchManager,
    exact: true
  }
  
];

export default routes;